import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  root: {
    height: '100%',
    paddingBottom: theme.spacing(2),
  },
  lineTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontWeight: 500,
    marginBottom: '4px',
  },
  lineBar: {
    height: 7,
    borderRadius: 5,
    backgroundColor: theme.palette.subscription.primary.light,
  },
  rowName: {
    fontWeight: 500,
  },
  rowValue: {
    fontWeight: 500,
  },
}))

export default styles
